import { Injectable } from '@angular/core';

import { ApiService, GlobalVar } from 'src/app/services';
import { Chapter } from 'src/app/models/chapters';
import { BookService } from '../book/book.service';

@Injectable({
  providedIn: 'root'
})
export class ChaptersService {

  public hasChapters: boolean = false;
  public systemTypes = [
    { title: "Belemmerend", type: 0 },
    { title: "Bezielend", type: 1 },
  ];

  constructor(
    public globalvar: GlobalVar,
    public apiService: ApiService,
    public bookService: BookService,
  ) { }

  post(body) {
    body.user_id = this.globalvar._user.id;
    return this.apiService.post(this.globalvar._createChapter, body);
  }

  put(id, body) {
    return this.apiService.post(`${this.globalvar._putChapter}/${id}`, body);
  }

  get() {

  }

  getAll() {
    // return this.apiService.get(`${this.globalvar._getChapters}/${this.globalvar._user.id}`);
  }

  getById(id, type) {
    let book = this.bookService.books.filter(x => x.system_type == type)[0];

    return book.chapter.filter(x => x.id == id)[0];
  }

  checkHasChapters() {
      let hasChapters = 0;
      this.bookService.books.forEach(async book => {
        this.bookService.systemTypes.forEach(systemType => {
          if (book.system_type === systemType.type) {
            if (book.chapter.length > 0) {
              hasChapters++;
            }
          }
        });
      });

      this.hasChapters = hasChapters == 2 ?? false;
  }
}
